<div class="mt-4  d-flex justify-content-between flex-wrap">
  <div class="search-cont gap-sm-3 ">
    <div class="s-in form-input me-0" style="position:relative">
      <mat-icon class="input-icon">search</mat-icon>
      <input type="text" placeholder="{{'Search...'}}" class="form-control" [(ngModel)]="searchInput"
        (input)="onSearch($event)" (keyup.enter)="onGo()" />
    </div>
  </div>
  <button mat-raised-button color="primary" class="primary-btn  ms-auto no-sh-btn add-pref-btn" type="submit"
    (click)="onAddBank()">
    <i class="fas fa-plus"></i> {{"COMMON.ADD" | translate}}
    {{"EMPLOYEE.JOBPREFERENCE.JOBPREFERENCE"|translate}}</button>
</div>
<div style="height: 55vh;overflow-y: auto;" class="w-100 overflow-auto" *ngIf="dataSource.data.length!=0">
  <table class="mt-2 mt-sm-3 mt-md-4 mat-elevation-z8" mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="job_category">
      <th mat-header-cell *matHeaderCellDef>{{"COMMON.JOB" | translate}} {{"COMMON.CATEGORY" | translate}}</th>
      <td mat-cell *matCellDef="let element" class="td-1">
        <div class="text-semibold"> {{element.j_c}}</div>
        <div>{{element.j_sc}}</div>
      </td>
    </ng-container>
    <ng-container matColumnDef="time">
      <th mat-header-cell *matHeaderCellDef>{{"COMMON.CREATEDAT" | translate}}</th>
      <td mat-cell *matCellDef="let element" class="td-1">
        <div> {{element.c_at}}</div>
      </td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>{{"COMMON.STATUS" | translate}}</th>
      <td mat-cell *matCellDef="let element" class="td-1">
        <div class="d-flex align-items-center">
          <div class="text-bold st-box  d-flex ">
            <span class="pending badge-c d-box" *ngIf="element.app=='2'">{{"Pending"|translate}}</span>
            <span class="active badge-c d-box" *ngIf="element.app=='1'">{{"Accepted"|translate}}</span>
            <span class="un-attend   badge-c d-box" *ngIf="element.app=='0'">{{"Rejected"|translate}}</span>
          </div>
          <i class="material-icons cursor-pointer more-ic" [matMenuTriggerFor]="menu">more_vert</i>
          <mat-menu #menu="matMenu">
            <button mat-menu-item color="primary" *ngIf="element.app!='1'" (click)="profileAcceptReject('accept',1,element)">
              <mat-icon class="kt-margin-r-0">thumb_up</mat-icon>
              <span>Accept Role</span>
            </button>
            <button mat-menu-item color="primary" *ngIf="element.app!='0'" (click)="profileAcceptReject('reject',0,element)">
              <mat-icon class="kt-margin-r-0">thumb_down</mat-icon>
              <span>Reject Role</span>
            </button>
          </mat-menu>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="shift">
      <th mat-header-cell *matHeaderCellDef>{{"EMPLOYEE.JOBPREFERENCE.SHIFT" | translate}}</th>
      <td mat-cell *matCellDef="let element" class="td-1">
        {{element.s_pw}}
      </td>
    </ng-container>
    <ng-container matColumnDef="interested">
      <th mat-header-cell *matHeaderCellDef>{{"EMPLOYEE.JOBPREFERENCE.INTERESTED" | translate}}</th>
      <td mat-cell *matCellDef="let element" class="td-1">
        <!-- {{element.int_ft }} -->
        {{ element.int_ft ? (element.int_ft === 1 ? 'Yes' : 'No') : 'No' }}
        <div class="text-bold" *ngIf="!element.int_ft">
          <span>--</span>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="willing_travel">
      <th mat-header-cell *matHeaderCellDef>{{"EMPLOYEE.JOBPREFERENCE.WILLING" | translate}}</th>
      <!-- <td mat-cell *matCellDef="let element" class="td-1">
        {{element.w_tt}}
      </td> -->
      <td mat-cell *matCellDef="let element" class="td-1">
        {{ element.w_tt ? (element.w_tt === 1 ? 'Yes' : 'No') : 'No' }}
      </td>

    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
<div class="mat-table__message" *ngIf="dataSource.data.length==0">
  <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
</div>
<div class="d-flex justify-content-between align-items-center flex-wrap pagination-bottom"
  *ngIf="dataSource.data.length!=0">
  <div class="me-3 text-grey d-flex align-items-center">
    Showing Items per page
    <select class="form-control sel-op ms-2" (change)="onPageSizeChange($event)" [(ngModel)]="config.itemsPerPage">
      <option [value]="item" *ngFor="let item of pageSizeOptions">{{ item }}</option>
    </select>
  </div>
  <div>
    <ngb-pagination [collectionSize]="count" [(page)]="config.currentPage" [pageSize]="config.itemsPerPage"
      [maxSize]="maxPaginationSize" (pageChange)="onPageChange($event)"></ngb-pagination>
  </div>
</div>